import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const SectionHeader = ({ title, subtitle, link, linkText = 'View All' }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-10">
    <div>
      <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a3a5c] mb-2">
        {title}
      </h2>
      {subtitle && (
        <p className="text-gray-600 text-sm md:text-base">{subtitle}</p>
      )}
    </div>
    {link && (
      <Link
        to={link}
        className="inline-flex items-center space-x-2 text-[#C9A967] hover:text-[#B8860B] transition-colors font-medium mt-4 md:mt-0"
      >
        <span>{linkText}</span>
        <ArrowRight className="h-4 w-4" />
      </Link>
    )}
  </div>
);
